<template>
<div>
  {{this.variantDisplay}}
</div>
</template>

<script>
export default {
  name: "inventoryName",
  props:['data'],
  computed : {
    variantDisplay() {
      let string = '';
      for (const [key, value] of Object.entries(this.data)) {
        string +=(`${key}: ${value} `);
      }
      return string;
    }
  },
  mounted: function () {
    this.$emit('variant-height', this.$el.clientHeight)
  }

};
</script>
